import { render, staticRenderFns } from "./Trivia6.vue?vue&type=template&id=09019db1&"
import script from "./Trivia6.vue?vue&type=script&lang=js&"
export * from "./Trivia6.vue?vue&type=script&lang=js&"
import style0 from "./Trivia6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports